import { Badge } from '@mantine/core';
import { POLICY_ASSIGNMENT_STATUS_COLORS } from '../utils/hrConstants';

interface Props {
  status: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function PolicyAssignmentStatusBadge({ status, size = 'sm' }: Props) {
  return (
    <Badge color={POLICY_ASSIGNMENT_STATUS_COLORS[status] ?? 'gray'} variant="light" size={size}>
      {status}
    </Badge>
  );
}
